module.exports = __webpack_public_path__ + "img/seminar.581c3b99.png";